<template>
  <div class="h-100 d-flex flex-column overflow-y-auto">
    <div class="sidebar-top">
      <div class="sidebar-item gap-10px flex-column">
        <download-btn></download-btn>
        <div class="d-flex gap-10px flex-wrap">
          <export-btn v-if="currentJob.apiJob?.sat?.permissions.can_continue === true"></export-btn>
          <share-btn v-if="currentJob.apiJob?.sat?.permissions.can_share === true"></share-btn>
          <delete-btn v-if="currentJob.apiJob?.sat?.permissions.can_delete === true"></delete-btn>
        </div>
      </div>
      <div class="sidebar-item" v-if="currentJob.state !== 'draft'">
        <job-queued></job-queued>
      </div>
      <div class="sidebar-item gap-20px flex-column" v-if="currentJob.state !== 'not_found'">
        <current-task></current-task>
      </div>
      <div class="sidebar-item gap-20px flex-column" v-if="currentJob.state ==='processing'">
        <notify></notify>
      </div>
      <div class="sidebar-item gap-20px flex-column" v-if="isCreditsInAllSatsEnabled && currentJob.state ==='processing'">
        <cancel-task ></cancel-task>
      </div>
      <div class="sidebar-item gap-20px flex-column"  v-if="complete === true && currentJob.apiJob?.sat?.permissions.can_continue === true">
        <continue-with></continue-with>
      </div>
      <div class="sidebar-item gap-20px flex-column" v-if="resultPage.isMobile === true">
        <feedback></feedback>
      </div>
    </div>
    <div class="sidebar-right-bot-ad" v-if="!isPremiumUser">
      <div class="d-flex justify-content-center">
        <div :id="adId"></div>
      </div>
      </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import ExportBtn from "../Elements/ExportBtn.vue";
import ContinueWith from "../Elements/ContinueWith.vue";
import JobQueued from "../Elements/JobQueued.vue";
import currentJob from "../../mixins/current_job.mixin";
import QueuePlaceInQueue from "../Elements/QueueState/QueuePlaceInQueue.vue";
import QueueGeneric from "../Elements/QueueState/QueueGeneric.vue";
import QueueProcessing from "../Elements/QueueState/QueueProcessing.vue";
import QueueComplete from "../Elements/QueueState/QueueComplete.vue";
import QueueFailed from "../Elements/QueueState/QueueFailed.vue";
import QueueFull from "../Elements/QueueState/QueueFull.vue";
import QueuePrepare from "../Elements/QueueState/QueuePrepare.vue";
import DownloadBtn from "../Elements/DownloadBtn.vue";
import ShareBtn from "../Elements/ShareBtn.vue";
import DeleteBtn from "../Elements/DeleteBtn.vue";
import ChangeOptionsBtn from "../Elements/ChangeOptionsBtn.vue";
import StartOverBtn from "../Elements/StartOverBtn.vue";
import Notify from "../Elements/Notify.vue";
import Feedback from "../Elements/Feedback.vue";
import user from "../../mixins/user.mixin";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";
import CurrentTask from "../Elements/CurrentTask.vue";
import Reconvert from "../../util/Reconvert";
import CancelTask from "../Elements/CancelTask.vue";

export default {
  name: "SidebarRightExport",
  props: {},
  components: {
    CancelTask,
    CurrentTask,
    Feedback,
    StartOverBtn,
    Notify,
    ChangeOptionsBtn,
    DeleteBtn,
    ShareBtn,
    DownloadBtn,
    QueuePrepare,
    QueueFull,
    QueueFailed,
    QueueComplete,
    QueueProcessing,
    QueueGeneric,
    QueuePlaceInQueue,
    JobQueued,
    ExportBtn,
    ContinueWith,
  },
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      adId: satGlobals.getProjectName().toLowerCase() + '_post_2',
      isCreditsInAllSatsEnabled: satGlobals.isCreditsInAllSatsEnabled(),
    };
  },
  mounted: function () {
  },
  created: function () {
    if (satGlobals.getProjectName().toLowerCase() === 'img2go') {
      this.adId = 'td-top-mpu-1';
    }
    if (satGlobals.getProjectName().toLowerCase() === 'online-convert') {
      this.adId = 'post_conversion_300x250';
    }
  },
  methods: {},
  computed: {
    reconvertLinks() {
      return Reconvert.getReconvertList(this.currentJob);
    }
  }
};
</script>
<style lang="scss" scoped>
.sidebar-item {
  padding: 20px 20px;
  border-bottom: 1px solid #CBCBCB;
  width: 100%;
  background: white;
  color: black;

  .dark-mode & {
    background:#272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.btn-box {
  min-height: 105px;
  height: 105px;
}
.sidebar-right-bot-ad {
  //border-top: 1px solid #CBCBCB;
  padding: 20px;
}
</style>
